import React from 'react';
import MainSidebar from './MainSidebar';
import { FiTool, FiSettings, FiMessageSquare } from 'react-icons/fi';

export default function ToolsSidebar() {
  const menuItems = [
    {
      id: 'tools_config',
      title: 'System & Configuration',
      links: [
        { path: '/tools', label: 'System Tools', icon: FiTool },
        { path: '/settings', label: 'Company Settings', icon: FiSettings },
        { path: '/moceanapi', label: 'MoceanAPI (SMS)', icon: FiMessageSquare }
      ]
    }
  ];

  return <MainSidebar moduleName="Tools & Settings" menuItems={menuItems} />;
}